import { useEffect, useRef, useState } from 'react';
import { t } from './i18n';
import { supabase } from './supabaseClient';
import { clientDinStare } from './conectare';

export default function FacebookCallback() {
  const [status, setStatus] = useState(t('callback', 'seConecteazaFb'));

  // Codul de autorizare e de UNICA FOLOSINTA, iar React.StrictMode executa
  // efectele de doua ori in dezvoltare: fara garda asta, functia de schimb e
  // chemata de doua ori cu acelasi cod si a doua cerere pica. Pe productie
  // StrictMode nu dubleaza, de aceea defectul nu s-a vazut niciodata aici.
  // Diagnosticat pe LinkedIn, 10 septembrie 2026, dupa patru ore de cautat.
  const pornit = useRef(false);

  useEffect(() => {
    if (pornit.current) return;
    pornit.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const stareIntoarsa = params.get('state');
    const errorCode = params.get('error_code');
    const errorMessage = params.get('error_message');

    if (errorCode) {
      console.log('Eroare Facebook:', errorCode, errorMessage);
      setStatus(t('callback', 'eroareConectare'));
      setTimeout(() => { window.location.href = `/?error=facebook_${errorCode}`; }, 1500);
      return;
    }

    if (!code || !stareIntoarsa) {
      window.location.href = '/';
      return;
    }

    // Intoarcerea trebuie sa fie raspunsul la o plecare din browserul acesta (vezi conectare.js).
    const state = clientDinStare(stareIntoarsa);
    if (!state) {
      console.error('Conectare oprita: codul de la intoarcere nu e cel de la plecare.');
      setStatus(t('callback', 'eroareConectare'));
      setTimeout(() => { window.location.href = '/?error=facebook_stare'; }, 1500);
      return;
    }

    async function proceseazaCallback() {
      try {
        setStatus(t('callback', 'seProceseaza'));
        // Sesiunea utilizatorului, nu cheia publica: functia verifica cine cheama si
        // daca are drept pe clientul din `state` (15 septembrie 2026, SECURITATE_PLAN.md).
        const { data: sesiune } = await supabase.auth.getSession();
        const tokenSesiune = sesiune?.session?.access_token;
        if (!tokenSesiune) {
          console.error('Eroare facebook-oauth: nu exista sesiune');
          setStatus(t('callback', 'eroareConectare'));
          setTimeout(() => { window.location.href = `/?error=oauth_fara_sesiune`; }, 2000);
          return;
        }
        const res = await fetch(
          `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/facebook-oauth?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`,
          {
            headers: {
              'Authorization': `Bearer ${tokenSesiune}`,
              'apikey': process.env.REACT_APP_SUPABASE_ANON_KEY
            }
          }
        );
        if (!res.ok) {
          let detaliu = '';
          try { const j = await res.json(); detaliu = j.error || j.detail || ''; } catch (e) {}
          console.error('Eroare facebook-oauth:', res.status, detaliu);
          setStatus(t('callback', 'eroareConectare'));
          setTimeout(() => { window.location.href = `/?error=oauth_failed`; }, 2000);
          return;
        }
        // Din 15 septembrie 2026 funcția nu mai leagă nicio pagină: întoarce lista de ales,
        // iar pagina se alege în aplicație (PAGINA_PRINCIPALA_PLAN.md). Răspunsul vechi
        // („ok” fără listă) rămâne înțeles, cât se pun lucrurile în producție.
        let raspuns = null;
        try { raspuns = await res.json(); } catch (e) {}
        if (raspuns && raspuns.alege) {
          window.location.href = `/?alege_pagina=${encodeURIComponent(raspuns.alege)}&client=${encodeURIComponent(state)}`;
          return;
        }
        setStatus(t('callback', 'conectatRedirect'));
        window.location.href = `/?facebook=connected&client=${state}`;
      } catch (err) {
        console.error('Eroare OAuth:', err);
        setStatus(t('callback', 'eroareConectare'));
        setTimeout(() => { window.location.href = `/?error=oauth_failed`; }, 2000);
      }
    }

    proceseazaCallback();
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'DM Sans, sans-serif', color: '#1A6B3C' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 40, marginBottom: 16 }}>⏳</div>
        <div>{status}</div>
      </div>
    </div>
  );
}